export const MAX_LENGTH_DESCRIPTION = 254;
export const MAX_LENGTH_LONG_DESCRIPTION = 4000;
